export function priceBounds(lane) {
  if (!lane || !['ready','thin','review'].includes(lane.status) || !lane.latestSaleAt) return null;
  const saleAt = Date.parse(lane.latestSaleAt);
  if (!Number.isFinite(saleAt) || saleAt > Date.now()) return null;
  const low = lane.valueGbp ?? lane.lowGbp, high = lane.valueGbp ?? lane.highGbp;
  return typeof low==='number' && typeof high==='number' && Number.isFinite(low) && Number.isFinite(high) && low>0 && high>=low ? {low,high} : null;
}

// Keep acquisition data and unsaved edits untouched: sorting is a view only.
export function sortInventoryRows(rows, order) {
  const [grader, direction] = String(order).split('-');
  if (!['ace', 'psa'].includes(grader) || !['asc', 'desc'].includes(direction)) return rows;
  return rows.map((row, index) => ({
    row, index, value: priceBounds(row.slab.market?.comps?.[grader])?.low ?? null,
  })).sort((a, b) => {
    if (a.value === null && b.value !== null) return 1;
    if (b.value === null && a.value !== null) return -1;
    if (a.value === b.value) return a.index - b.index;
    return direction === 'desc' ? b.value - a.value : a.value - b.value;
  }).map(item => item.row);
}
export function portfolioStats(slabs, now=Date.now(), allInventory=false) {
  const pc=allInventory?slabs:slabs.filter(s=>s.intendedUse==='randys_pc');
  const stats={count:pc.length,ace:{lowPence:0,highPence:0,priced:0,review:0,older:0},psa:{lowPence:0,highPence:0,priced:0,review:0,older:0}};
  for(const slab of pc) for(const key of ['ace','psa']) {
    const lane=slab.market?.comps?.[key],bounds=priceBounds(lane);if(!bounds)continue;
    const target=stats[key];target.lowPence+=Math.round(bounds.low*100);target.highPence+=Math.round(bounds.high*100);target.priced++;
    if(lane.status!=='ready')target.review++;
    if(now-Date.parse(lane.latestSaleAt)>90*86400000)target.older++;
  }
  return stats;
}
